var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframIndex"},[_c('iframe',{ref:_vm.preUrl,attrs:{"id":"statistics","src":_vm.fullPath,"frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }